import { render, staticRenderFns } from "./candidatecourseId.vue?vue&type=template&id=109f23c6&scoped=true&"
import script from "./candidatecourseId.vue?vue&type=script&lang=js&"
export * from "./candidatecourseId.vue?vue&type=script&lang=js&"
import style0 from "./candidatecourseId.vue?vue&type=style&index=0&id=109f23c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109f23c6",
  null
  
)

export default component.exports